import { apiRequest } from './client'
import type { Meta } from '@/types/meta'

interface MetaResponse {
  config_bucket_name: string
}

// GET /gui/v1/meta (PRD 21) - authenticated, single-field response.
export async function getMeta(): Promise<Meta> {
  const meta = await apiRequest<MetaResponse>('/gui/v1/meta')
  return { configBucketName: meta.config_bucket_name }
}
